import { render, staticRenderFns } from "./MonitorDeAtividades.vue?vue&type=template&id=28606c78"
import script from "./MonitorDeAtividades.vue?vue&type=script&lang=js"
export * from "./MonitorDeAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports